import { imageSchema } from '../../../poll/questions/schemaFields';
import { createBasicWelcomeSchema } from '../schemaFields';

export const schema = createBasicWelcomeSchema(
  'WELCOME_SIMPLE',
  {
    breadcrumbs: { type: 'string' },
    image: imageSchema,
    imageBackground: { type: 'string' },
    title: { type: 'string' },
    text: { type: 'string' },
    cta: { type: 'string' },
    disclaimer: { type: 'string' },
  },
  ['cta'],
);
